import React from 'react';
import shortid from 'shortid';

// Components
import ProfileTabSection from '../../../components/Profile/ProfileTabSection';
import ProfileDataBlock from '../../../components/Profile/ProfileDataBlock';

const PlayerProfileAwards = ({ awards }) => (
  <ProfileTabSection heading="Awards">
    <ProfileDataBlock heading="" >
      {
        awards.map((award) => {
          return <p key={shortid.generate()}>{award}</p>
        })
      }
    </ProfileDataBlock>
  </ProfileTabSection>
)

export default PlayerProfileAwards;



// WEBPACK FOOTER //
// ./src/screens/Profile/ProfileSections/PlayerProfileAwards.js